<form [formGroup]="form">
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>
          <span class="label-content"> Firt Name</span>

          <input
            class="form-control"
            type="text"
            name="firstname"
            maxlength="40"
            placeholder="{{ 'register.firstName.placeholder' | cxTranslate }}"
            formControlName="firstName"
          />

          <cx-form-errors [control]="form.get('firstName')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>
          <span class="label-content"> Last Name</span>

          <input
            class="form-control"
            type="text"
            name="lastName"
            maxlength="40"
            placeholder="{{ 'register.lastName.placeholder' | cxTranslate }}"
            formControlName="lastName"
          />
          <cx-form-errors [control]="form.get('lastName')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>
          <span class="label-content"> Job Title</span>
          <input class="form-control" type="text" name="jobTitle" maxlength="40" placeholder="Job Title" formControlName="jobTitle" />
          <cx-form-errors [control]="form.get('jobTitle')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>
          <span class="label-content">Work Email</span>
          <input class="form-control" type="text" name="email" maxlength="40" placeholder="Job Title" formControlName="email" />
          <cx-form-errors [control]="form.get('email')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>
          <span class="label-content">Phone Number</span>

          <div class="container-phone-number">
            <countries-dropdown
              [disabled]="form.disabled"
              [isocode]="country?.isocode"
              [countries$]="countries$"
              (_onSelectCountry)="setCountry($event)"
              [form]="form"
              [controlName]="'dialingCode'"
              [label]="''"
              [placeholder]="''"
              [displaySelectedContryName]="false"
              [displaySelectedContryDiallingCode]="true"
            ></countries-dropdown>

            <input
              class="form-control"
              type="phone"
              name="phoneNumber"
              maxlength="40"
              placeholder="..."
              formControlName="phoneNumber"
              [mask]="country?.phoneMask || ''"
              (keypress)="validateInput($event)"
            />
          </div>

          <cx-form-errors [control]="form.get('phoneNumber')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>
          <span class="label-content">Extension</span>
          <input class="form-control" type="text" name="extension" maxlength="40" placeholder="..." formControlName="extension" />
          <cx-form-errors [control]="form.get('extension')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group m-0">
        <div class="form-check m-0">
          <label class="m-0">
            <input type="checkbox" name="optIn" formControlName="optIn" />
            <span class="form-check-label"> I would like to receive the latest updates on products and promotions </span>
            <cx-form-errors [control]="form.get('optIn')"></cx-form-errors>
          </label>
        </div>
      </div>
    </div>
  </div>
</form>
